import {
    fetchJson, NEW_CHECKOUT_SUMMARY, NOTIFY_REFRESHING_CHECKOUT_SUMMARY
} from '../../GlobalStateContainer'
import { notifyError } from "../UserMessaging";

export function notifyRefreshingSummary() {
    return { type: NOTIFY_REFRESHING_CHECKOUT_SUMMARY }
}

function onRefreshSummary(summary) {
    return { type: NEW_CHECKOUT_SUMMARY, summary: summary.result }
}

const getSummaryErrorMessage = 'An error occured while trying to refresh the summary. Please reload the page and try again, or contact customer service';

const refreshSummarySpec = {
    endpoint: (state) => state.constants.navigation.cartSummaryEndpoint,
    init: { method: 'POST', credentials: 'same-origin' },
    notify: notifyRefreshingSummary,
    extract: (response) => response.json(),
    onSuccess: onRefreshSummary,
    onError: (diagMsg) => notifyError(getSummaryErrorMessage, diagMsg)
}
export const refreshSummary = fetchJson(refreshSummarySpec)

